var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLMTxContainer',{attrs:{"tx":_vm.tx}},[_c('div',{staticClass:"options"},_vm._l((_vm.human_options),function(option){return _c('div',{key:option},[_vm._v(" "+_vm._s(option)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }